import { PROVINCES } from '@/constants';

export const BuyerCommissionName = 'Buyer Agent\'s Commission';

export const CommissionType = {
  FlatRate: 'FlatRate',
  Typical: 'Typical',
  Custom: 'Custom',
};

export const ProvinceTypicalCommissionMessage = {
  [PROVINCES.AB]: 'Typical commission: 3.5% on the first $100K and 1.5% on the balance of the final sale price (plus GST)',
  [PROVINCES.BC]: 'Typical commission: 3.5% on the first $100K and 1.25% on the balance of the final sale price (plus GST)',
};

export default {
  BuyerCommissionName,
  CommissionType,
  ProvinceTypicalCommissionMessage,
};
